const twoPointersProblems = [
  {
      title: "Two Sum II - Input Array is Sorted",
      url: "https://leetcode.com/problems/two-sum-ii-input-array-is-sorted/"
    },
    {
      title: "Remove Duplicates from Sorted Array",
      url: "https://leetcode.com/problems/remove-duplicates-from-sorted-array/"
    },
    {
      title: "3Sum",
      url: "https://leetcode.com/problems/3sum/"
    },
    {
      title: "Container With Most Water",
      url: "https://leetcode.com/problems/container-with-most-water/"
    },
    {
      title: "Trapping Rain Water",
      url: "https://leetcode.com/problems/trapping-rain-water/"
    }
];
export default twoPointersProblems;